import React, { ReactNode } from "react";
import styled from "styled-components";

import theme from "../../../theme";
import Hyperlink from "../../Hyperlink";
import {
  VerticalStep,
  VerticalStepName,
  VerticalWrapper,
} from "../../ProgressBar/VerticalProgressBar/components";

interface IImageWrapperProps {
  imageWidth?: number;
}

const VerticalStepWrapper = styled(Hyperlink)`
  width: 100%;
`;

const ImageWrapper = styled.div<IImageWrapperProps>`
  align-self: center;
  flex-shrink: 0;
  flex-grow: 0;
  width: ${({ imageWidth }: IImageWrapperProps): string =>
    imageWidth ? `${imageWidth}px` : "59px"};
  margin-right: ${theme.margins.marginBase};
  padding: ${theme.margins.paddingPage} 0;
  text-align: center;
  height: 107px;
`;

const Image = styled.img`
  max-height: 100%;
  margin: auto;
`;

export interface IStep {
  imageSrc?: string;
  label: string;
  productUrl?: string;
  subLabel?: string | ReactNode;
}

export interface IProps {
  className?: string;
  horizontalPadding?: number;
  imageWidth?: number;
  onClick?: () => void;
  steps: IStep[];
}

const InstantSearchList = (props: IProps): JSX.Element | null => {
  const { className, imageWidth, onClick, steps, horizontalPadding } = props;

  return (
    <VerticalWrapper
      onClick={onClick}
      className={className}
      horizontalPadding={horizontalPadding}
    >
      {steps.map((step: IStep, index: number) => (
        <VerticalStepWrapper key={`step-${index}`} to={step.productUrl}>
          <VerticalStep showBottomBorder={true}>
            <VerticalStepName label={step.label} subLabel={step.subLabel} />
            {step.imageSrc && (
              <ImageWrapper imageWidth={imageWidth}>
                <Image src={step.imageSrc} alt={step.label} />
              </ImageWrapper>
            )}
          </VerticalStep>
        </VerticalStepWrapper>
      ))}
    </VerticalWrapper>
  );
};

export default InstantSearchList;
